<template>
  <div class="container-fluid">
    <!-- Accounts Table -->
    <div class="mt-2 row">
      <div
        class="container-fluild table-main remove-styles2 remove-border responsiveness"
      >
        <table
          v-for="(
            transacItem, index
          ) in incomeStatementSummaryData.transactionsByAccountCategory"
          :key="index"
          id="table"
          class="table remove-styles mt-0 table-hover table-header-area"
        >
          <thead class="table-header-ar" v-if="index == 0">
            <tr class="font-weight-bold">
              <th>ACCOUNTS</th>
              <th class="text-right"></th>
              <th class="text-right">
                <div class="text-dak s-14">{{ formatDate(startDate) }}</div>
                <div class="text-dak s-14">to {{ formatDate(endDate) }}</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- Assets Section -->
            <tr class="table-header-area-main">
              <td>
                <a href="#" class="text-decoration-none fw-400 text-dak s-14">{{
                  transacItem.categoryName
                }}</a>
              </td>
              <td></td>
              <td class="text-right"></td>
            </tr>
            <tr v-for="(item, indx) in transacItem.accounts" :key="indx">
              <td>
                <a
                  style="color: #0b55d4"
                  href="#"
                  class="text-decoration-none fw-500 s-14"
                  >{{ item.accountName }}</a
                >
              </td>
              <td></td>
              <td class="text-right">
                {{ currentUser.currencySymbol }}
                {{ formatAmount(item.totalAmount) }}
              </td>
            </tr>
          </tbody>
          <div class="mt-2"></div>
          <tbody>
            <tr class="table-header-area-mai">
              <td>
                <div class="text-dak s-14 font-weight-bold">
                  Total {{ transacItem.categoryName }}
                </div>
              </td>
              <td class="text-right text-dak font-weight-bold s-14"></td>
              <td class="text-right">
                <div
                  class="text-right text-dak font-weight-bold s-14"
                  v-if="transacItem.categoryName === 'Income'"
                >
                  {{ currentUser.currencySymbol }}
                  {{
                    Math.abs(totalIncome(transacItem.accounts)).toLocaleString()
                  }}
                </div>
                <div
                  class="text-right text-dak font-weight-bold s-14"
                  v-if="transacItem.categoryName === 'Expense'"
                >
                  {{ currentUser.currencySymbol }}
                  {{
                    Math.abs(
                      totalExpense(transacItem.accounts)
                    ).toLocaleString()
                  }}
                </div>
              </td>
            </tr>
            <tr
              class="table-header-area-main"
              v-if="
                index ===
                incomeStatementSummaryData.transactionsByAccountCategory
                  .length -
                  1
              "
            >
              <td class="s-14">
                <div class="text-dak font-weight-bold">Net Balance</div>
              </td>
              <td></td>
              <td class="text-right s-14">
                <div
                  class="font-weight-bold"
                  :style="{ color: netTotal < 0 ? 'red' : '#00000' }"
                >
                  {{ currentUser.currencySymbol }}
                  {{ netBalance.toLocaleString() }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, inject } from "vue";
import { useStore } from "vuex";
import dateFormatter from "../../../services/dates/dateformatter";

const props = defineProps({
  startDate: {
    type: String,
    default: "",
  },
  endDate: {
    type: String,
    default: "",
  },
  incomeStatementSummaryData: {
    type: Object,
    default: () => ({}),
  },
});
const store = useStore();

// Sample Data

const currentUser = computed(() => {
  if (store && Object.keys(store.getters.currentUser).length > 0)
    return store.getters.currentUser;
  return "";
});

const totalExpense = (item) => {
  return item.reduce((sum, item) => sum + item.totalAmount, 0);
};
const totalIncome = (item) => {
  return item.reduce((sum, item) => sum + item.totalAmount, 0);
};
const calculateNetBalance = (data) => {
  let income = 0;
  let expense = 0;

  data.forEach((item) => {
    if (item.categoryName === "Income") {
      income += totalIncome(item.accounts);
    } else if (item.categoryName === "Expense") {
      expense += totalExpense(item.accounts);
    }
  });

  return income - expense;
};

const netBalance = computed(
  () =>
    calculateNetBalance(
      props.incomeStatementSummaryData.transactionsByAccountCategory
    ) // `transactions` should be your full list of `transacItem`s
);

const formatDate = (date) => {
  return dateFormatter.monthDayYear(date);
};

const fundsData = computed(() => {
  const funds = {};

  // Process all transactions
  props.incomeStatementSummaryData.transactionsByAccountCategory?.forEach(
    (category) => {
      category.accounts.forEach((account) => {
        const fundName = account.fund;

        // Initialize fund if not exists
        if (!funds[fundName]) {
          funds[fundName] = {
            income: [],
            expense: [],
            incomeTotal: 0,
            expenseTotal: 0,
            balance: 0,
          };
        }

        // Add to appropriate category
        if (category.categoryName === "Income") {
          funds[fundName].income.push(account);
          funds[fundName].incomeTotal += account.totalAmount;
        } else {
          funds[fundName].expense.push(account);
          funds[fundName].expenseTotal += Math.abs(account.totalAmount);
        }

        // Calculate balance
        funds[fundName].balance =
          funds[fundName].incomeTotal - funds[fundName].expenseTotal;
      });
    }
  );

  return funds;
});

// Format Amount
const formatAmount = (amount) =>
  amount.toLocaleString("en-NG", { minimumFractionDigits: 2 });
</script>

<style scoped>
.table th,
.table td {
  border-top: none;
}
.active {
  background: #ffffff;
  color: #08162e;
  font-weight: 700;
  width: 81px;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  /* padding: 15px 0; */
}
.bg-secondary {
  background-color: #f8f9fa !important;
}
button.el-button {
  height: 36px !important;
  width: 139px !important;
  padding: 13px 24px !important;
  font-size: 13px !important;
}
.table-main {
  width: 100% !important;
  box-shadow: 0 0.063rem 0.25rem #02172e45 !important;
  /* border: 0.063rem solid #dde2e6 !important; */
  /* border-radius: 30px !important; */
  text-align: left !important;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem !important;
}

.remove-styles {
  border: none !important;
  box-shadow: none !important;
  border-bottom: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.remove-styles2 {
  padding-right: 0;
  padding-left: 0;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
table tbody tr,
table thead tr {
  border-bottom: 1px solid rgba(0, 0, 1, 0.2);
}
table tbody tr:first-child {
  border-bottom: none !important;
}
table tbody tr:last-child {
  border-bottom: none !important;
}

.remove-border {
  box-shadow: none !important;
}
.table {
  width: 100% !important;
  box-shadow: none !important;
  border: none !important;
  text-align: left;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem;
}

.table thead th {
  font-weight: 700 !important;
  color: #000000 !important;
  font-size: 14px !important;
}
.table tbody tr {
  font-weight: 400 !important;
  color: #000000 !important;
  font-size: 14px !important;
}

.table-header-area-main {
  background-color: #d4dde4;
  /* background-color: #f4f4f4; */
}

.table-header-area {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
